import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";

import DashboardNav from "./dashboradNavbar";
import Sidebar from "./Sidebar";
import ProjectsSection from "./ProjectsSection";
import ProfileSidebar from "./ProfileSidebar";
import "./Dashboard.css";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { FilterProvider } from "./FilterContext";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../Firebase/firebase";
import ConatctSale from "./Contactsale";
import raisalogo from "../../Images/RaisaN.svg";
import dis from "../../Images/discovernew.svg";
import inb from "../../Images/inboxnew.svg";
import req from "../../Images/requestnew.svg";
import sav from "../../Images/savenew.svg";
import noti from "../../Images/notificationnew.svg";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";

/* const Dashboard = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
 
  useEffect(() => {
    const auth = getAuth();
    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        await user.reload(); // Reload user to get the latest email verification status
        if (user.emailVerified) {
          // If email is verified, update Firestore
          const userDocRef = doc(db, "User", user.uid);
          await updateDoc(userDocRef, {
            verified: true,
          });

         
        }
      }
      setLoading(false); // Stop loading state whether user is present or not
    });
    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);
 
  if (loading) {
    return <div>Loading...</div>; 
  }
 
  document.body.style.background = "rgba(234, 239, 255, 1)";

  return (<div className="dashboard-container">
    <FilterProvider>
    <div className="dashborad-navbar"><DashboardNav User={currentUser} /></div>
      <div className="main-content">
       <div className="dashborad-sidebar"> <Sidebar /></div>
        <div  className="dashboard-prjct-section"><ProjectsSection/></div>
        <div className="dashboard-profile">
          {currentUser && <ProfileSidebar User={currentUser} />}
          <ConatctSale/>
        </div> 
      </div>
    

    </FilterProvider>
	
    </div>
  );
}; */

const Dashboard = () => {
  const [userSubsDetail, setUserSubDetail] = useState([]);

  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isVerified, setIsVerified] = useState("test");
  const [userDetail, setUserDetail] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [userProject, setUserProject] = useState([]);

  const navigate = useNavigate(); // To programmatically navigate after logout

  const handleLogout = () => {
    localStorage.removeItem("selectedProject");
    const auth = getAuth(); // Get the current authentication instance
    signOut(auth)
      .then(() => {
        // Sign-out successful, redirect user to login page
        navigate("/login"); // Redirecting to login page after logout
      })
      .catch((error) => {
        // An error happened during logout
        console.error("Logout Error:", error);
      });
  };

  const fetchData = async () => {
    // if (!User) return;

    try {
      // Fetch User Data
      const userQuery = query(
        collection(db, "User"),
        where("id", "==", currentUser.uid)
      );
      const userQuerySnapshot = await getDocs(userQuery);
      if (userQuerySnapshot.empty) {
        console.error("No user found");
        return;
      }
      const userDetail = userQuerySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }))[0]; // Get the first document
      setUserDetail(userDetail);

      // Fetch User Projects
      const userProjectQuery = query(
        collection(db, "UserProject"),
        where("userId", "==", currentUser.uid)
      );
      const userProjectQuerySnapshot = await getDocs(userProjectQuery);
      const userProjects = userProjectQuerySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setUserProject(userProjects);

      // Fetch User Subscription Data
      const userSubsQuery = query(
        collection(db, "UserSubs"),
        where("userId", "==", currentUser.uid)
      );
      const receivedSnapshot = await getDocs(userSubsQuery);
      const userSubsDetail = receivedSnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }))[0]; // Get the first document
      setUserSubDetail(userSubsDetail);

      // Fetch Request Sent Count
      /*  const sentQuery = query(collection(db, "ConnectionReq"), where("fromUserId", "==", User.uid));
      const sentSnapshot = await getDocs(sentQuery);
      setRequestSentCount(sentSnapshot.size); */
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      meta.setAttribute("content", "width=device-width, initial-scale=1");
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [currentUser, db]);
  useEffect(() => {
    const auth = getAuth();
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        await user.reload(); // Reload to get the latest email verification status

        // Real-time listener for user's Firestore document
        const userDocRef = doc(db, "User", user.uid);
        const unsubscribeFirestore = onSnapshot(userDocRef, (docSnap) => {
          if (docSnap.exists()) {
            const userData = docSnap.data();
            // Check if 'verified' field is true and update state
            setIsVerified(userData.verified || false);
          }
        });

        // Stop loading once the document is fetched
        setLoading(false);

        // Clean up Firestore listener on unmount
        return () => unsubscribeFirestore();
      }
      setLoading(false); // Stop loading if no user is logged in
    });

    // Cleanup auth listener on unmount
    return () => unsubscribeAuth();
  }, []);

  if (loading) {
    return (
      <div class="loading-dots">
        Loading<span>.</span>
        <span>.</span>
        <span>.</span>
      </div>
    ); // Display a loading state or spinner
  }

  document.body.style.background = "rgba(234, 239, 255, 1)";

  return (
    <>
      {isVerified === true && (
        <div className="dashboard-container">
          <FilterProvider>
            <div className="dashborad-navbar">
              <Navbar />
            </div>

            {/* <div className="mobile-dashborad-navbar">
          <div className="mob-nav">
            <img src={raisalogo} alt='raisalogo'/>
            <ul className="header-ul-m">
      <li
        className="headerli "
        
      >
        <img className="headerli-img " src={dis} alt="discover" />
        
      </li>
      <li
        className="headerli"
       
      >
        <Link to="/inbox" style={{ textDecoration: 'none',display:"flex",gap:'8px' }} >
        <img className="headerli-img" src={inb} alt="inbox"  />
        
          
        </Link>
      </li>
      <li
        className="headerli"
       
      >
         <Link to="/requestpage" style={{ textDecoration: 'none' , display:"flex",gap:'8px' }} >
        <img className="headerli-img" src={req} alt="request" />
       
         
        </Link>
      </li>
      <li
        className="headerli"
       
      > <Link  style={{ textDecoration: 'none',display:"flex",gap:'8px' }} >
        <img className="headerli-img" src={sav} alt="saved" />
       
          
        </Link>
      </li>
      <li
        className="headerli"
       
      ><Link  style={{ textDecoration: 'none' ,display:"flex",gap:'8px'}} >
        <img className="headerli-img" src={noti} alt="notifications" />
        
          
        </Link>
      </li>
    </ul>
    <div className="mob-profile-nav">
         <div className="mob-profileimgnav">
          <div
          onClick={() => setShowModal(!showModal)}
          // style={{ cursor: 'pointer', fontSize: '2rem' }}
        >
                    <img src={userDetail?.profilePicture} alt="nav-profile"  className="mobile-nav-profile-pic" />
        </div>
        {showModal && (
        <div className="filtermodal-content-p">
          <ProfileSidebar User={currentUser}/>
        </div>
      )}
        </div>
          </div>
          </div>
        </div> */}
            <div className="dash-navbar-m">
              <div className="req-nav-cntr">
                <img
                  className="req-raisa-logo-img"
                  src={raisalogo}
                  alt="raisa"
                />
                <ul className="req-header-ul">
                  {/* <li
        className="headerli dis"
       
      >
          <Link to="/dashboard" style={{ textDecoration: 'none'}} >
        <img className="headerli-img " src={dis} alt="discover" />
        
       
          
          </Link>
        
      </li> */}
                  <li className="req-headerli">
                    <Link
                      to="/inbox"
                      style={{ textDecoration: "none", height: "18px" }}
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        href="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="18"
                          height="18"
                          fill="url(#pattern0_3137_814)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_3137_814"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              href="#image0_3137_814"
                              transform="scale(0.015625)"
                            />
                          </pattern>
                          <image
                            id="image0_3137_814"
                            width="64"
                            height="64"
                            href="data:image/png;base64,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"
                          />
                        </defs>
                      </svg>
                      {/* <img className="headerli-img"  src={inb} alt="inbox"  / > */}
                    </Link>
                  </li>

                  <li className="req-headerli">
                    <Link
                      to="/requestpage"
                      style={{ textDecoration: "none", height: "18px" }}
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        href="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="18"
                          height="18"
                          fill="url(#pattern0_3137_817)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_3137_817"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              href="#image0_3137_817"
                              transform="scale(0.015625)"
                            />
                          </pattern>
                          <image
                            id="image0_3137_817"
                            width="64"
                            height="64"
                            href="data:image/png;base64,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"
                          />
                        </defs>
                      </svg>
                    </Link>
                  </li>
                  <li
                    className="req-headerli"
                    onClick={() => alert("Coming Soon")}
                  >
                    <Link style={{ textDecoration: "none", height: "18px" }}>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        href="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          y="0.5"
                          width="18"
                          height="18"
                          fill="url(#pattern0_3137_820)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_3137_820"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              href="#image0_3137_820"
                              transform="scale(0.015625)"
                            />
                          </pattern>
                          <image
                            id="image0_3137_820"
                            width="64"
                            height="64"
                            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAB2AAAAdgB+lymcgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJ0SURBVHic7Zs/axRBHIYfT0G9QqukEPxDwEIxsbAVcliLnyEqhFjrF7HXVuytbT2FaOMforGOxORMYe7SRYvdIbN7d9nZndl5T5kHBo65ud+8v+f2FhbmwJ0u8AR4DwyBPzM2hsA68Bg4W6MvJ64An2egSdfxCbgcqvkz/1jzZnwETlc1d8pBwCPgemnuC7Dl8NmYXKCY8wawBjz1LfyWotkV34It8oBi1jchig6sgpshCrbMd47yDqoWdxwKdq3Xuw1DxWTHet2duirHRcB/TRKgDqAmCVAHUJMEqAOoSQLUAdQkAeoAapIAdQA1SYA6gJokQB1ATRKgDqAmCVAHUJMEqAOoSQLUAdQkAeoAapIAdQA1SYA6gJokQB1ATRKgDqAmCVAHUONyUDI0HeAecBe4ms9tAq/ycSjIdCwHHJ2763vWWgA+MP1463q+xoe+Ve/AsxYQTsAisE31Gd/tfG1TagmIdQ9YBF4D86X5Q8Yv+fl8rY8EZ2IIMM3PWXMjsoPM54DzZAeyR9b7c0SUUIXPT+Aa8IPiJT4E7kxYexv4XVr7E1iquefM3APqNG8IIWEmBDRp3uArQS7Ap3mDjwSpgBDNG5pKkAkI2bxhkoRfwK1jPiMR0EbzhroSogtYIvuXRhvNG+pIiCogRvMGVwnRBMRs3uAiIbiAPavgRj53k/Hm94FeiA0r6OV72XvvkH0hJ4BvFOV486602QbFqyJm84Ye4xJGwNfSnO/jOwCrpaLl0fZlP41JP4fyeBhio5PAyykbDIDlEJs0ZJniHzvt8YIsexA6ZDb7ZPeELeAZcDHUBh5cAp6TZdojy3gfx0f9v6oVxW6Z6UeDAAAAAElFTkSuQmCC"
                          />
                        </defs>
                      </svg>
                    </Link>
                  </li>
                  <li
                    className="req-headerli"
                    onClick={() => alert("Coming Soon")}
                  >
                    {" "}
                    <Link style={{ textDecoration: "none", height: "18px" }}>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        href="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          y="0.5"
                          width="18"
                          height="18"
                          fill="url(#pattern0_3137_823)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_3137_823"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              href="#image0_3137_823"
                              transform="scale(0.015625)"
                            />
                          </pattern>
                          <image
                            id="image0_3137_823"
                            width="64"
                            height="64"
                            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAB2AAAAdgB+lymcgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASRSURBVHic7ZtLjBRFGMd/M7OLBJHHiYswyLosLI/EiyEkhKM3w0lwiYoJwcgRwXAwcoADwRAS5YgQxEhMSEyMnCAhvBJlOcljXN7PyGERVjC47i7j4auyatzudaqmurrB/SWdrZmp+r5/VVdVV31dC+P8vynl6LsKLFTpc8CtHLVEpRs4DtT/dR0D5ueoKwqLgIeMrry+HgALclMXgdOYyp4BPgTWA73W9ydyU5cxczCV/BFos35rRxpE/z47lqhyLEfAPCv9NTBsfR5S3yXlfW74AHOHbwD9SMWHVPqG9fu6XBRmQAVYBZwlfeJLu3qBlcTtpUFZCVwiuXJ3kTF/GPhBpe+m5O0D3oqsvSWmIOPZrsRfwEFgLdAxRtkOleegKmPb+ErZLjTzgGsY0X8CXwCzPGxVgd3AoGXvKtAVRGkGdNLYjWvAawHsLgB+tuzeo4BPidnAHYzIb4FJAe1PUja1/Vv49apMKNO4tj9E4yInFBXgG8vPKfVd7nyMEXUEWdVlRTtw1PK3MUNfTfEKMtHpjczLEXzOVL7qwBMiLpuT+BxzN9ZE9Pu+5XdXRL8NTAceKRHXiDseK8AV5ft3YJqvoVaWmWuAySq9CxhpwZYrI8j6AuAl4N2Ivv/hGHIHhshnhTZV+a4jE2NUJmAmv59iO7fQgZQneD59fIdAN/CCSp/0tBGC4+rvRDxDab4NYDs762kjBL1WemFqrjFopQdoLnjaCEHNSntFlFvtAcPInj8v+jChte6xMoZGBzp+iek0hT5M4MQZnx4wEYnwAlz0cRoYraED0eaETwN0YVZ9RWqACjDXtbBPA9hjrZaaKx72TXCeB1ptgDyfAJrcGuApnhNPYGqYfUiUJ0ENmXUvx3DWJHpn6DwnufaACcCrKl2ECVCjtXRiluhN4doAczHxviI2QBvmBjWFawPYY6yIDQCOm6LnsQGcJkLfBnhKMZbBmouIJsj4mM15TAywaFxHtJ1zKeTSA6ZhlppF6v4avSjrwiFI6tIAPZiwU55RoDROq7/twNuhjb+OCYEPIi8nikYV80r9EaI5CO8BjzEvIraGMpwB2zA6HyPavakAeyyD+pBCIV5IptCGaLQ178FT837LyBCwiXyP1jZLCdFqnzDZ52pkqVX4V/X5WWMpol3XY4lL4Z1WwWXBpcVjOaYeO5IypD0GZ1jpM4FFxcR+bzAjKUNaA1y10m8EkxMfW/v1pAxpk5o+mFRGXj/vxC/+p88HJzrPuHw3sAF5cTsCLMZxBbsD99OdRb22u1RcUwI2M/b5/qJfD5EzTKmP72ae6y8iQ6LaRF6bKvCZSn+HnP50oQdYodIfAbcdy99ENkh/OJYLRjvwGyZY6bKIKmOCr/1kc+wuCvsw3bHHodw7VrkvM9AVjU7MknQA+Z+h/2KxyltHdp5OQc4isgVzNweA1SQPhzJy5wes/J9kLS7G5qYEHEAqrqkB32PiivOBN2k8BH0A2c7WI2jMnBLwKaP/ByDpGkTu/LOw83SmE9gL3Gd0xfuRCS/qmM+rlduQ7q7PFt9BhsNwaolxxsmEvwEKS6y5O8P0nQAAAABJRU5ErkJggg=="
                          />
                        </defs>
                      </svg>
                    </Link>
                  </li>
                </ul>
                <div className="mob-profile-nav">
                  <div className="mob-profileimgnav">
                    <div
                      onClick={() => setShowModal(!showModal)}
                      // style={{ cursor: 'pointer', fontSize: '2rem' }}
                    >
                      <img
                        src={userProject[0]?.profilePicture}
                        alt="nav-profile"
                        className="mobile-dash-profile-pic"
                      />
                    </div>
                    {showModal && (
                      <div className="filtermodal-content-p">
                        <ProfileSidebar User={currentUser} />
                        <button
                          className="dash-logout-btn"
                          onClick={handleLogout}
                        >
                          Logout
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="main-content">
              {isVerified && (
                <>
                  <div className="dashborad-sidebar">
                    <Sidebar />
                  </div>
                  <div className="dashboard-prjct-section">
                    <ProjectsSection />
                  </div>
                  <div className="dashboard-profile">
                    {currentUser && <ProfileSidebar User={currentUser} />}
                    <ConatctSale />
                  </div>
                </>
              )}
              {isVerified === false && (
                <div>
                  Your Account is under review. Please wait for approval.
                </div>
              )}
            </div>

            <div className="mobile-main-content">
            <ProjectsSection />
            </div>
          </FilterProvider>
        </div>
      )}
      {isVerified === false && (
        <div>Your Account is under review. Please wait for approval.</div>
      )}
    </>
  );
};

export default Dashboard;
